import { isBefore } from 'date-fns'

const isMatchInTheFuture = ({ matchStartDate }: { matchStartDate: Date }) => {
  return isBefore(new Date(), matchStartDate)
}

export default isMatchInTheFuture
